import { colors, isPresetColor } from '@flex-design-system/fx-colors';

function getColor(color) {
  return isPresetColor(color) ? colors[color] : color;
}

export { getColor };
//# sourceMappingURL=colors.mjs.map
